import { render, staticRenderFns } from "./FeedbackAnalyticsTableCellRendererComments.vue?vue&type=template&id=83c36108&scoped=true&"
import script from "./FeedbackAnalyticsTableCellRendererComments.vue?vue&type=script&lang=js&"
export * from "./FeedbackAnalyticsTableCellRendererComments.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackAnalyticsTableCellRendererComments.vue?vue&type=style&index=0&id=83c36108&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83c36108",
  null
  
)

export default component.exports